export default {
    data() {
        return {
            //项目包的数组
            packages: [],
        }
    },
    methods: {
        //获取搜索出来的项目包
        getSearchPackages(name) {
            //发送给后台的数据
            let data = {
                name: name,
                length: "999",
                offset: "0"
            }
            this.$post("package/search", data).then(res => {
                // console.log(res.data.result.data);
                this.packages = res.data.result.data;
                for(let val of this.packages){
                    if(val.package_product){
                        val.year = val.package_product[0].product_year;
                        val.start_stydy_time = val.package_product[0].start_stydy_time;
                        val.end_study_time = val.package_product[0].end_study_time;
                    }
                }
            })
        },
        //根据现在的时间判断项目的进行状态
         state(start_stydy_time, end_study_time) {
            let time = new Date().getTime()
            if (time > end_study_time) {
                return "已完成"
            } else if (time < end_study_time && time > start_stydy_time) {
                return "学习中"
            } else {
                return "报名中"
            }
        },
        //跳转项目包主页
        toProjectHomePage(id) {
            this.$router.push({
                path: "/pojecthomepage",
                query: {
                    id: id
                }
            })
        },
    },
    created() {
        // console.log(this.$route.query.name)
        //获取搜索的文字再调用搜索方法
        this.getSearchPackages(this.$route.query.name);
    }
}